var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPermanent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.957,
    height: 8.561,
    viewBox: "0 0 18.957 8.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M467.37,349.994a2.53,2.53,0,0,0-.918.177,2.279,2.279,0,0,0,0,4.257,2.549,2.549,0,0,0,2.554-.434l1.956-1.7-1.956-1.695a2.411,2.411,0,0,0-1.636-.611ZM474,352.281l1.956,1.695a2.549,2.549,0,0,0,2.554.434,2.279,2.279,0,0,0,0-4.257,2.549,2.549,0,0,0-2.554.434Zm3.592,4.277a4.547,4.547,0,0,1-2.953-1.084l-2.155-1.872-2.155,1.872a4.559,4.559,0,0,1-4.59.788,4.162,4.162,0,0,1-2.694-3.39,4.4,4.4,0,0,1,0-1.183,4.109,4.109,0,0,1,2.694-3.39,4.559,4.559,0,0,1,4.59.788l2.155,1.872,2.155-1.872a4.559,4.559,0,0,1,4.59-.788,4.109,4.109,0,0,1,2.694,3.39,4.4,4.4,0,0,1,0,1.183,4.109,4.109,0,0,1-2.694,3.39,4.787,4.787,0,0,1-1.636.3Z",
    transform: "translate(-463 -348)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermanent);
export default __webpack_public_path__ + "static/media/permanent.a9ae50f3.svg";
export { ForwardRef as ReactComponent };